import {
  AnchorButtonDarkBg,
  AnchorButtonDarkBgGhost,
  AnchorButtonPrimary,
  AnchorButtonPrimaryGhost,
  AnchorButtonSecondary,
  AnchorButtonSecondaryGhost,
  AnchorButtonTertiary,
  AnchorButtonTertiaryGhost,
} from './expressive-anchor-button.styles';
import { ArrowRight } from './expressive-button-base.styles';
import { ExpressiveButtonBasesTypes } from './expressive-button-base.types';
import { svgIcons } from '@exploration/icons';
import { AnchorButtonProps } from '@midwest/web/button';

// --------------------------------------------------------------------------

export type ExpressiveAnchorButtonProps = Omit<
  AnchorButtonProps,
  'size' | 'variant' | 'weight'
> &
  ExpressiveButtonBasesTypes;

// --------------------------------------------------------------------------

export const ExpressiveAnchorButton = ({
  ariaId,
  buttonId,
  analyticsName,
  showArrow = false,
  variant = 'primary',
  size = 'default',
  weight = 'default',
  children,
  ...rest
}: ExpressiveAnchorButtonProps) => {
  let Button = AnchorButtonPrimary;
  if (variant === 'darkBg') {
    Button = weight === 'ghost' ? AnchorButtonDarkBgGhost : AnchorButtonDarkBg;
  } else if (variant === 'primary') {
    Button =
      weight === 'ghost' ? AnchorButtonPrimaryGhost : AnchorButtonPrimary;
  } else if (variant === 'secondary') {
    Button =
      weight === 'ghost' ? AnchorButtonSecondaryGhost : AnchorButtonSecondary;
  } else if (variant === 'tertiary') {
    Button =
      weight === 'ghost' ? AnchorButtonTertiaryGhost : AnchorButtonTertiary;
  }

  return (
    <Button
      role="link"
      data-analytics-id={buttonId}
      data-analytics-cta-text={analyticsName}
      data-dd-action-name={analyticsName}
      aria-label={ariaId}
      $eVariant={variant}
      $eWeight={weight}
      $eSize={size}
      {...rest}
    >
      {children} {showArrow && <ArrowRight icon={'arrowRight' as svgIcons} />}
    </Button>
  );
};
